import { Navigate, Route, Routes } from "react-router-dom";
import LoginScreen from "../pages/auth/LoginScreen";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ForgotOTP from "../pages/auth/ForgotOTP";
import ResetPassword from "../pages/auth/ResetPassword";
import Dashboard from "../pages/Dashboard";
import Prompts from "../pages/Prompts";
import UrlList from "../pages/urls/UrlList";
import UrlSettings from "../pages/urls/UrlSettings";
import KnowledgeBase from "../pages/knowlegdeBase/KnowledgeBase";
import KnowledgeBaseDetails from "../pages/knowlegdeBase/KnowledgeBaseDetails";
import KnowledgeBaseCreate from "../pages/knowlegdeBase/KnowledgeBaseCreate";
import AIAgentSettings from "../pages/AIAgentSettings";
import PromptHistory from "../pages/promptHistory/PromptHistory";
import PromptHistoryDetails from "../pages/promptHistory/PromptHistoryDetails";
import AskAiText from "../pages/askAi/AskAiText";
import AskAiVoice from "../pages/askAi/AskAiVoice";
import ProfileScreen from "../pages/ProfileScreen";
import Users from "../pages/users/Users";
import UserDetails from "../pages/users/UserDetails";
import ProjectAdminUsageDetails from "../pages/users/ProjectAdminUsageDetails";
import FormBuilder from "../pages/formBuilder/FormBuilder";
import SuperAdminDashboard from "../pages/superAdmin/SuperAdminDashboard";
import UsageHistoryDetails from "../pages/superAdmin/UsageHistoryDetails";
import ProjectList from "../pages/project/ProjectList";
import ProjectDetails from "../pages/project/ProjectDetails";
import AddProject from "../pages/project/AddProject";
import Settings from "../pages/Settings";
import SupportTicket from "../pages/SupportTicket";
import SupportTicketChat from "../pages/SupportTicketChat";
import ProjectHistory from "../pages/superAdmin/UsageHistory";
import ProjectHistoryDetails from "../pages/superAdmin/UsageHistoryDetails";
import SuperAdminSupportTicket from "../pages/SuperAdminSupportTicket";
import InvoiceList from "../pages/invoices/InvoiceList";
import InvoiceEditor from "../pages/invoices/InvoiceEditor";
import InvoiceDetails from "../pages/invoices/InvoiceDetails";
import BillingSettings from "../pages/invoices/BillingSettings";
import AiModelPricing from "../pages/superAdmin/AiModelPricing";
import AdminInvoiceList from "../pages/invoices/AdminInvoiceList";

const PrivateRoute = ({ element }) => {
  const token = localStorage.getItem("token");
  return token ? element : <Navigate to="/login" replace />;
};

const AppRouter = () => {
  return (
    <Routes>
      {/* Auth */}
      <Route path="/" element={<LoginScreen />} />
      <Route path="/login" element={<LoginScreen />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/forgot-otp" element={<ForgotOTP />} />
      <Route path="/reset-pass" element={<ResetPassword />} />

      {/* Regular user */}
      <Route path="/dashboard" element={<PrivateRoute element={<Dashboard />} />} />
      <Route path="/prompts" element={<PrivateRoute element={<Prompts />} />} />
      <Route path="/url-list" element={<PrivateRoute element={<UrlList />} />} />
      <Route path="/url-settings" element={<PrivateRoute element={<UrlSettings />} />} />
      <Route path="/knowledge-base" element={<PrivateRoute element={<KnowledgeBase />} />} />
      <Route path="/knowledge-base-details/:doc_id" element={<PrivateRoute element={<KnowledgeBaseDetails />} />} />
      <Route path="/knowledge-base-create" element={<PrivateRoute element={<KnowledgeBaseCreate />} />} />
      <Route path="/ai-agent-settings" element={<PrivateRoute element={<AIAgentSettings />} />} />
      <Route path="/prompt-history" element={<PrivateRoute element={<PromptHistory />} />} />
      <Route path="/prompt-history-details" element={<PrivateRoute element={<PromptHistoryDetails />} />} />
      <Route path="/ask-ai" element={<Navigate to="/ask-ai/text" replace />} />
      <Route path="/ask-ai/text" element={<PrivateRoute element={<AskAiText />} />} />
      <Route path="/ask-ai/voice" element={<PrivateRoute element={<AskAiVoice />} />} />
      <Route path="/user-list" element={<PrivateRoute element={<Users />} />} />
      <Route path="/user-details/:id" element={<PrivateRoute element={<UserDetails />} />} />
      <Route path="/project-admin-usage" element={<PrivateRoute element={<ProjectAdminUsageDetails />} />} />
      <Route path="/form-builder" element={<PrivateRoute element={<FormBuilder />} />} />
      <Route path="/support-ticket" element={<PrivateRoute element={<SupportTicket />} />} />
      <Route path="/support-ticket-chat/:ticketId" element={<PrivateRoute element={<SupportTicketChat />} />} />
      <Route path="/support-ticket-chat" element={<PrivateRoute element={<SupportTicketChat />} />} />
      <Route path="/profile" element={<PrivateRoute element={<ProfileScreen />} />} />
      <Route path="/settings" element={<PrivateRoute element={<Settings />} />} />

      {/* Super admin */}
      <Route path="/super-admin-dashboard" element={<PrivateRoute element={<SuperAdminDashboard />} />} />
      <Route path="/usage-history-details" element={<PrivateRoute element={<UsageHistoryDetails />} />} />
      <Route path="/project-list" element={<PrivateRoute element={<ProjectList />} />} />
      <Route path="/project-details/:id" element={<PrivateRoute element={<ProjectDetails />} />} />
      <Route path="/project-add" element={<PrivateRoute element={<AddProject />} />} />
      <Route path="/project-details/:id/invoices" element={<PrivateRoute element={<InvoiceList />} />} />
      <Route path="/project-details/:id/invoices/settings" element={<PrivateRoute element={<BillingSettings />} />} />
      <Route path="/project-details/:id/invoices/new" element={<PrivateRoute element={<InvoiceEditor />} />} />
      <Route path="/project-details/:id/invoices/:invoiceId/view" element={<PrivateRoute element={<InvoiceDetails />} />} />
      <Route path="/project-details/:id/invoices/:invoiceId" element={<PrivateRoute element={<InvoiceEditor />} />} />
      <Route path="/usage-history" element={<PrivateRoute element={<ProjectHistory />} />} />
      <Route path="/usage-history-details/:id" element={<PrivateRoute element={<ProjectHistoryDetails />} />} />
      <Route path="/admin-support-ticket" element={<PrivateRoute element={<SuperAdminSupportTicket />} />} />
      <Route path="/admin-support-ticket-chat/:ticketId" element={<PrivateRoute element={<SupportTicketChat />} />} />
      <Route path="/admin-support-ticket-chat" element={<PrivateRoute element={<SupportTicketChat />} />} />
      <Route path="/ai-model-pricing" element={<PrivateRoute element={<AiModelPricing />} />} />
      <Route path="/admin-invoices" element={<PrivateRoute element={<AdminInvoiceList />} />} />
      <Route path="/admin-invoices/:invoiceId/view" element={<PrivateRoute element={<InvoiceDetails />} />} />
    </Routes>
  );
};

export default AppRouter;
